var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUnlock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83333 9.16667V5.83334C4.83229 4.80005 5.21523 3.80323 5.90781 3.03639C6.60039 2.26956 7.55319 1.78742 8.58125 1.68358C9.60932 1.57974 10.6393 1.86159 11.4712 2.47443C12.3032 3.08727 12.8777 3.98738 13.0833 5.00001M3.16667 9.16667H14.8333C15.7538 9.16667 16.5 9.91286 16.5 10.8333V16.6667C16.5 17.5871 15.7538 18.3333 14.8333 18.3333H3.16667C2.24619 18.3333 1.5 17.5871 1.5 16.6667V10.8333C1.5 9.91286 2.24619 9.16667 3.16667 9.16667Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnlock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/unlock.568c8e61.svg";
export { ForwardRef as ReactComponent };